<template>
  <div class="page">
    <div class="left">
      <div class="intro">
        <span class="subtitle">hi, my name is</span>
        <span class="title">Rushil Koul<em>.</em></span> <br />
        <span class="subtitle s2">i'm a <em>computer science student
          </em> and <br class="visible-on-desktop"><em>software developer</em>.</span>
        <FunFacts />
      </div>
      <nav class="navigation" aria-label="Main navigation">
        <button class="nav-item" :class="{ 'nav-active': activeSection === 'about' }" @click="scrollToSection('about')" :aria-current="activeSection === 'about' ? 'page' : undefined">about me</button>
        <button class="nav-item" :class="{ 'nav-active': activeSection === 'projects' }" @click="scrollToSection('projects')" :aria-current="activeSection === 'projects' ? 'page' : undefined">stuff i've worked on</button>
        <button class="nav-item" :class="{ 'nav-active': activeSection === 'skills' }" @click="scrollToSection('skills')" :aria-current="activeSection === 'skills' ? 'page' : undefined">what i know</button>
      </nav>
      <div class="connections jcsb">
        <div class="connections">
          <a href="https://github.com/rushilkoul" target="_blank" aria-label="Visit GitHub profile">
            <i class="bi bi-github"></i>
          </a>
          
          <a href="https://linkedin.com/in/rushilkoul" target="_blank" aria-label="Visit LinkedIn profile">
            <i class="bi bi-linkedin"></i>
          </a>
        </div>
        <span>© 2025 Rushil Koul</span>
        <button @click="toggleTheme" class="theme-toggle" :aria-label="`Switch to ${isDarkTheme ? 'light' : 'dark'} theme`">
          <i :class="isDarkTheme ? 'bi bi-moon-fill' : 'bi bi-sun-fill'"></i>
        </button>
      </div>
    </div>
    <div class="right" v-if="!showAllProjects">
      <section v-motion-fade-visible class="section about" id="about" aria-labelledby="about-heading">
        <h2 id="about-heading">about me</h2>
        <span>
          I build things that need to work and look right.
          <em>frontend</em> and <em>python tooling</em> is where I'm strongest, but I'm just as comfortable going <em>low-level</em> when the problem calls for it. 
          <em>C++</em>, compilers, network tools, the whole deal.
        </span>
      </section>

      <section v-motion-fade-visible class="section journey" id="projects" aria-labelledby="projects-heading">
        <h2 id="projects-heading">projects</h2>
        
        <div class="project-timeline">
          <div class="timeline-years">
          </div>
          <div class="project-container">
            <ProjectItem
              v-for="project of mainprojects" 
              v-bind:key="project" :name="project.name" :tag="project.tag"
              :desc="project.desc" :long="project.long" :year="project.year" :url="project.url"
              :languages="project.languages" :icon="project.icon" :type="project.type"
              :cert="project.cert ? project.cert : false"
              :level="project.level ? project.level : 0"
              :img="project.img ? project.img : 'none'"
            />
          </div>
        </div>
        <button class="collapser" @click="collapseTimeline">see all</button>
        </section>
      <section v-motion-fade-visible class="section" id="skills" aria-labelledby="skills-heading">
        <h2 id="skills-heading">tech stack</h2>
        <div class="skills">
          <SkillItem v-motion-fade-visible :duration="155"
          v-for="skill of skills" v-bind:key="skill"
          :name="skill.name" :year="skill.year" :icon="skill.icon" :desc="skill.desc"
          :prof="skill.prof"/>
        </div>
        <!-- <p
          v-motion-fade-visible
          style="font-size:0.75rem; margin: 0; text-align: right; color: var(--text-color-secondary)">
          *experience durations include both personal and professional project work
        </p> -->
        <!-- languages & frameworks -->
        <div class="skills">
          <SkillItem v-motion-fade-visible :duration="155"
          v-for="framework of frameworks" v-bind:key="framework"
          :name="framework.name" :year="framework.year" :icon="framework.icon" :desc="framework.desc"
          :prof="framework.prof"/>
        </div>
      </section>
    </div>
    <div class="right" v-else>
      <section v-motion-fade-visible class="section journey">
        <h2>
          all my work
          <button class="collapser" @click="collapseTimeline"> 
            <i class="bi bi-arrow-return-left"></i> go back
          </button>
        </h2> 
        
        
        <div class="project-timeline">
          <div class="timeline-years">
          </div>
          <div class="project-container">
            <ProjectItem
              v-for="project of projects" v-bind:key="project" :name="project.name" :tag="project.tag"
              :desc="project.desc" :long="project.long" :year="project.year" :url="project.url"
              :languages="project.languages" :icon="project.icon" :type="project.type"
              :cert="project.cert ? project.cert : false"
              :level="project.level ? project.level : 0"
              :img="project.img ? project.img : 'none'"

            />
          </div>
        </div>
        </section>
    </div>
  </div>
</template>

<script>
import ProjectItem from '@/components/ProjectItem.vue'
import FunFacts from '@/components/FunFacts.vue'
import SkillItem from '@/components/SkillItem.vue'
export default {
  name: 'HomeView',
  components: {
    ProjectItem,
    FunFacts,
    SkillItem
  },
  data() {
    return {
      isDarkTheme: localStorage.getItem('theme') === 'dark' || !localStorage.getItem('theme'),
      isCollapsed: true,
      sectionBounds: [],
      showAllProjects: false,
      activeSection: 'about',
      mainprojects: {
        "Bridge": {
        "name": "Bridge",
        "tag": "P2P LAN messenger",
        "type": "project",
        "desc": "TUI P2P LAN messenger in C++. Features auto peer discovery and persistent TCP connections",
        "long": true,
        "url": "https://github.com/rushilkoul/bridge",
        "languages": ["C++"],
        "year": 26,
        "icon": "github",
        img: "bridge.mp4"
      },
      "Velvet": {
        "name": "Velvet",
        "tag": "C++ UI framework",
        "type": "project",
        "desc": "Beginner-friendly C++ GUI library built on SFML. Built for FOSSHack India 2026.",
        "long": true,
        "url": "https://github.com/rushilkoul/velvet",
        "languages": ["C++", "SFML"],
        "year": 26,
        "icon": "weblink",
        img: "velvet.mp4"
      },
        "PYQJIIT": {
          name: "PYQJIIT",
          tag: "questions archive",
          type:"project",
          desc: "For students, by students. Allows JIIT students to login and upload question papers for all to view and practice",
          long: true,
          url: "https://pyqjiit.vercel.app",
          languages: ["React", "JavaScript", "Supabase"],
          year: 25,
          icon: "weblink",
          img: "pyqjiit.mp4"
        },
        "BunkMyJIIT": {
          name: "BunkMyJIIT",
          tag: "room availability tracker",
          type:"project",
          desc: "Really useful tool for JIIT students to track venue availability across campus",
          long: true,
          url: "https://bunkmyjiit.vercel.app",
          languages: ["Python", "HTML", "JavaScript"],
          year: 25,
          icon: "weblink",
          img: "bunkmyjiit.mp4"
        },
        "ByteSweep": {
          name: "ByteSweep",
          tag: "cleanup tool",
          type:"project",
          desc: "Lightweight python command-line tool that cleans up corrupted duplicates of files. Built for post-data recovery cleanups. 1000+ files processed in test runs",
          long: true,
          url: "https://github.com/rushilkoul/ByteSweep",
          languages: ["Python"],
          year: 25,
          icon: "github",
          img: "bytesweep.gif"
        },
        "Bhalurent": {
          name: "Bhalurent",
          tag: "multiplayer shooting game",
          type:"project",
          desc: "My best work in game development: A fully networked multiplayer FPS you can play with your friends. Originally designed to be a VALORANT clone, it quickly became really fun to play and work on",
          long: true,
          url: "https://gist.github.com/rushilkoul/e8dd1476bc49b6edea0c68864b6b7033",
          languages: ["Unity", "C#"],
          year: 22,
          icon: "link",
          img: "bhalurent.mp4"
        },
      },

      projects: {
        "Bridge": {
        "name": "Bridge",
        "tag": "P2P LAN messenger",
        "type": "project",
        "desc": "Encrypted terminal-based P2P LAN messenger in C++. Auto peer discovery over UDP broadcast, persistent TCP connections, ncurses TUI with multiple chat windows.",
        "long": true,
        "url": "https://github.com/rushilkoul/bridge",
        "languages": ["C++"],
        "year": 26,
        "icon": "github"
      },
      "Velvet": {
        "name": "Velvet",
        "tag": "C++ UI framework",
        "type": "project",
        "desc": "Beginner-friendly C++ GUI library built on SFML. Flexbox-inspired layout system, six widget types, declarative style map API. Built end-to-end at FOSSHack India 2026.",
        "long": true,
        "url": "https://rushilkoul.github.io/velvet",
        "languages": ["C++", "SFML"],
        "year": 26,
        "icon": "weblink"
      },
      "osdjam": {
          type:"achievement",
          name: "Won a 5-day <em>game jam</em> at my college",
          year: 25,
          level: 1
        },
        "PYQJIIT": {
          name: "PYQJIIT",
          tag: "questions archive",
          type:"project",
          desc: "For students, by students. Allows JIIT students to login and upload question papers for all to view and practice",
          long: true,
          url: "https://pyqjiit.vercel.app",
          languages: ["React", "JavaScript", "Supabase"],
          year: 25,
          icon: "weblink",
        },
        "BunkMyJIIT": {
          name: "BunkMyJIIT",
          tag: "room availability tracker",
          type:"project",
          desc: "Really useful tool for JIIT students to track venue availability across campus",
          long: true,
          url: "https://bunkmyjiit.vercel.app",
          languages: ["Python", "HTML", "JavaScript"],
          year: 25,
          icon: "weblink",
        },
        "graduated": {
          type:"achievement",
          name: "<em>Graduated</em> from high school  ",
          year: 25,
          level: 0,
          cert: true
        },
        "ByteSweep": {
          name: "ByteSweep",
          tag: "cleanup tool",
          type:"project",
          desc: "Lightweight python command-line tool that cleans up corrupted duplicates of files. Built for post-data recovery cleanups. 1000+ files processed in test runs",
          long: true,
          url: "https://github.com/rushilkoul/ByteSweep",
          languages: ["Python"],
          year: 25,
          icon: "github"
        },
        "schoolelec": {
          type:"achievement",
          name: "Developed the <em>Voting Infrastructure</em> at my school.<br>Used by <em>700+ students</em>",
          year: 24,
          level: 2
        },
        "compufest24": {
          type:"achievement",
          name: "<em>First place</em> in Filmmaking @ Compfest 2024, Seth Anandram Jaipuria",
          year: 24,
          level: 1
        },
        "FootageGuru": {
          name: "FootageGuru",
          tag: "video editing software",
          type:"project",
          desc: "Video editor that cuts out silent parts of long footage",
          long: true,
          url: "https://github.com/rushilkoul/FootageGuru",
          languages: ["Electron","Vue", "JavaScript","Python"],
          year: 23,
          icon: "github"
        },
        "Nexus": {
          name: "Nexus",
          tag: "AI assistant",
          type:"project",
          desc: "Behaviour tree based personal assistant designed to be installed into classrooms",
          url: "https://github.com/rushilkoul/Nexus",
          languages: ["Python"],
          year: 23,
          icon: "github",
          long: true
        },
        "compufest22": {
          type:"achievement",
          name: "<em>First place</em> in Filmmaking @ Compfest 2022, Seth Anandram Jaipuria",
          year: 22,
          level: 1
        },
        "TACS": {
          name: "TACS",
          tag: "website",
          type:"project",
          desc: "Official webpage of a student-led organisation that aims to connect students worldwide",
          url: "https://theartconnectingstudents.github.io",
          languages: ["Vue", "JavaScript", "HTML"],
          year: 22,
          icon: "weblink",
          long: true
        },
        "SearchDropdown": {
          name: "SearchDropdown",
          tag: "library",
          type:"project",
          desc: "A clean search dropdown element library designed for Vue",
          long: true,
          languages: ["Vue", "JavaScript", "HTML" ],
          year: 22,
          url: "https://github.com/rushilkoul/search-dropdown",
          icon: "github"
        },
        "Bhalurent": {
          name: "Bhalurent",
          tag: "multiplayer shooting game",
          type:"project",
          desc: "My best work in game development: A fully networked multiplayer FPS you can play with your friends. Originally designed to be a VALORANT clone, it quickly became really fun to play and work on",
          long: true,
          url: "https://gist.github.com/rushilkoul/e8dd1476bc49b6edea0c68864b6b7033",
          languages: ["Unity", "C#"],
          year: 22,
          icon: "link"
        },
        "OakScript": {
          name: "OakScript",
          tag: "compiler",
          type:"project",
          desc: "Simple compiler written in Python",
          url: "https://github.com/rushilkoul/OakScript",
          languages: ["Python"],
          year: 21,
          icon: "github",
        },
        "Mello": {
          name: "Mello",
          tag: "chatbot",
          type:"project",
          desc: "A context-unaware text to speech chatbot",
          url: "https://rushilkoul.github.io/mello/mello.html",
          languages: ["HTML", "JavaScript"],
          year: 21,
          icon: "weblink",
        },
        "BotKraft": {
          name: "BotKraft",
          tag: "discord bot",
          type:"project",
          desc: "A multipurpose server moderation and utility discord bot",
          url: "https://replit.com/@RushilKoul/botkraft-discord",
          languages: ["JavaScript", "Node.JS"],
          year: 21,
          icon: "link",
        },
        "QuoteBot": {
          name: "QuoteBot",
          tag: "discord bot",
          type:"project",
          desc: "A discord bot to vote on pinning users' iconic messages.",
          languages: ["JavaScript", "Node.JS"],
          year: 21,
          icon: "github",
          url: "https://github.com/rushilkoul/QuoteBot",
        },
        "RKPad": {
          name: "RKPad",
          tag: "text editor",
          type:"project",
          desc: "Text editor written with Tkinter",
          url: "https://github.com/rushilkoul/RKPad",
          languages: ["Python"],
          year: 20,
          icon: "github",
          long: true,
        },
        "JARVIS & VANI": {
          name: "JARVIS & VANI",
          tag: "AI assistants",
          type:"project",
          desc: "My first attempt at making AI personal assistants based on decision trees.",
          long: true,
          languages: ["Python"],
          year: 20,
          url: "https://github.com/rushilkoul/JARVIS-VANI",
          icon: "github"
        },
        "nco18": {
          type:"achievement",
          name: "<em>Gold Medalist</em> in the National Cyber Olympiad<br>2018-19",
          year: 18,
          level: 1
        },
        "nso18": {
          type:"achievement",
          name: "<em>Bronze Medalist</em> in the National Science Olympiad 2018-19",
          year: 18,
          level: 3
        },
        "nso17": {
          type:"achievement",
          name: "<em>Gold Medalist</em> in the National Science Olympiad <br>2017-18",
          year: 17,
          level: 1
        },
        "The 2D Time": {
          name: "The 2D Time",
          tag: "game",
          type:"project",
          desc: "My second game; A simple 2D platformer with a couple levels",
          url: "https://drive.google.com/file/d/1eJtZBwy0hbSmr5jSY-Hv9K_cTYRfLRFO/view?usp=sharing",
          languages: ["Unity", "C#"],
          year: 17,
          icon: "link",
          long: true
        },
        "The Simple Runner": {
          name: "The Simple Runner",
          tag: "game",
          type:"project",
          desc: "My first ever unity project, a simple 3D maneuvering game",
          long: true,
          url: "https://drive.google.com/file/d/1DA5hZVxUQrlCfdiNuF1A4TUfGmuuA5m3/view?usp=sharing",
          languages: ["Unity", "C#"],
          year: 17,
          icon: "link"
        }
      },
      skills : {
        "blender": {
          name: "Blender",
          year: 18,
          icon: 'https://upload.wikimedia.org/wikipedia/commons/0/0c/Blender_logo_no_text.svg',
          desc: '3D modelling, rigging, and compositing for game assets and animations',
          prof: 'Expert',
        },
        "photoshop": {
          name: "Adobe Photoshop",
          year: 17,
          icon: 'https://upload.wikimedia.org/wikipedia/commons/a/af/Adobe_Photoshop_CC_icon.svg',
          desc: 'advanced photo manipulation, concept art, textures for game assets and UI design',
          prof: 'Expert',
        },
        "aftereff": {
          name: "Adobe After Effects",
          year: 18,
          icon: 'https://upload.wikimedia.org/wikipedia/commons/c/cb/Adobe_After_Effects_CC_icon.svg',
          desc: 'motion graphics, VFX and short videos and animations',
          prof: 'Advanced',
        },
        "gb": {
          name: "GarageBand",
          year: 19,
          icon: 'https://upload.wikimedia.org/wikipedia/en/f/f7/GarageBand_App.png',
          desc: 'soundtrack composition, audio mixing, and sound design',
          prof: 'Advanced',
        },
        "unity": {
          name: "Unity",
          year: 17,
          icon: '-unity',
          desc: 'game development in C#',
          prof: 'Advanced',
        },
        "prproj": {
          name: "Adobe Premiere Pro",
          year: 23,
          icon: 'https://upload.wikimedia.org/wikipedia/commons/4/40/Adobe_Premiere_Pro_CC_icon.svg',
          desc: 'editing short-form video content',
          prof: 'intermediate',
        },
      },
      frameworks : {
        "python": {
          name: "Python",
          icon: 'https://upload.wikimedia.org/wikipedia/commons/0/0a/Python.svg',
          desc: 'personal assistants, automation tools and scripts',
          // prof: 'Advanced',
        },
        "js": {
          name: "JavaScript",
          icon: 'https://upload.wikimedia.org/wikipedia/commons/9/99/Unofficial_JavaScript_logo_2.svg',
          desc: 'interactive front-end development and scripting for web apps',
          // prof: 'Advanced',
        },
        "css": {
          name: "CSS",
          icon: 'https://upload.wikimedia.org/wikipedia/commons/6/62/CSS3_logo.svg',
          desc: 'built beautiful and responsive layouts and front-end UI',
        },
        "cpp": {
          name: "C++",
          icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/ISO_C%2B%2B_Logo.svg/1280px-ISO_C%2B%2B_Logo.svg.png',
          desc: 'my go-to for low-level projects, networking tools, and performance-critical code',
        },
        "cs": {
          name: "C#",
          icon: 'https://upload.wikimedia.org/wikipedia/commons/f/ff/C-Sharp_Logo.svg',
          desc: 'used extensively in Unity for game development',
        },
        "node": {
          name: "Node.JS",
          icon: 'https://cdn-icons-png.flaticon.com/512/5968/5968322.png',
          desc: 'back-end logic and full-stack applications',
        },
        "react": {
          name: "React",
          icon: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg',
          desc: 'built component-driven user interfaces with seamless API integration',
        },
        "vercel": {
          name: "Vercel",
          icon: '!vercel',
          desc: 'deployed and managed multiple web applications',
        },
        "vue": {
          name: "Vue.JS",
          icon: 'https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg',
          desc: 'developed fast, reactive front-end apps with reusable components',
        },
        "electron": {
          name: "Electron",
          icon: 'https://upload.wikimedia.org/wikipedia/commons/9/91/Electron_Software_Framework_Logo.svg',
          desc: 'built cross-platform desktop apps with HTML, CSS, and JS',
        },
        "heroku": {
          name: "Heroku",
          icon: 'https://www.vectorlogo.zone/logos/heroku/heroku-icon.svg',
          desc: 'deployed and managed cloud hosted scripts and apps',
        },       
      }

    }
  },
  methods: {
    toggleTheme() {
      this.isDarkTheme = !this.isDarkTheme;
      document.documentElement.setAttribute('data-theme', this.isDarkTheme ? 'dark' : 'light');
      localStorage.setItem('theme', this.isDarkTheme ? 'dark' : 'light');
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        this.activeSection = sectionId;
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    debounce(fn, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn.apply(this, args), delay);
      };
    },
    collapseTimeline() {
      // let sectionElement = document.querySelectorAll('.section')[1];
      // this.isCollapsed ? sectionElement.classList.remove('collapsed') : sectionElement.classList.add('collapsed');
      let button = document.querySelector('button.collapser')

      this.isCollapsed ? button.innerText = 'See Less' : button.innerText = 'See All';
      this.showAllProjects = !this.showAllProjects;
      this.isCollapsed = !this.isCollapsed

      const resizeEvent = new Event('resize', { bubbles: true, cancelable: true });
      window.dispatchEvent(resizeEvent);
      window.scrollTo(0,0)
      // this.calculateSectionBounds(this.sectionBounds);

    },
    setupTimeline() {
      // create an array that automatically goes from 2017
      // (my oldest project) to the current year

      const d = new Date();
      let maxnum = d.getFullYear() - 2000
      let years = []
      let usedYears = []

      for (let i = 17; i <= maxnum; i++) {
        years.push(i)
      }
      years.reverse(); // eg: [25, 24, 23, 22, 21, 20, 19, 18, 17]

      let yearHeads = [] // first element of each of the years (latest project of that year)

      for (let year of years) {
        let head = document.querySelector(`.proj_year_${year}`)
        if (head) {
          yearHeads.push(head); usedYears.push(year)
        } else continue;
      }
      let topBoundingValues = []
      for (let firstYearElm of yearHeads) {
        topBoundingValues.push(firstYearElm.getBoundingClientRect().top)
      }

      let heightRectValues = []
      for (let value of topBoundingValues) {
        let next = topBoundingValues[topBoundingValues.indexOf(value) + 1]
        if (next) {
          heightRectValues.push(next - value - 48)
        }
      }
      // now begin creating year cards and vertical lines
      let finalOffset = 0
      let yearParent = document.querySelector(".timeline-years")
      yearParent.innerHTML = ""
      for (let i in yearHeads) {
        let head = document.createElement("span");
        let vl = document.createElement("div");
        vl.classList = 'vl';
        finalOffset += 48;

        if (!heightRectValues[i]) {
          let lastHeight = document.querySelector(".project-container").getBoundingClientRect().height - finalOffset
          vl.style.height = `${lastHeight}px`
        } else {
          finalOffset += heightRectValues[i]
        }
        head.innerText = `20${usedYears[i]}`
        vl.style.height = `${heightRectValues[i]}px`
        yearParent.appendChild(head)
        yearParent.appendChild(vl)

      } 
    },
    calculateSectionBounds(sectionBounds) {
      sectionBounds.splice(0, sectionBounds.length)
      let sections = document.querySelectorAll(".section")

      for (let section of sections) {
        sectionBounds.push(section.getBoundingClientRect().y + window.scrollY - 200)
      }
      sectionBounds.shift();
      sectionBounds.push(document.documentElement.scrollHeight)
    }
  },
  created() {
    this.debouncedSetupTimeline = this.debounce(this.setupTimeline, 100);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debouncedSetupTimeline);
  },
  async mounted() {
    // Initialize theme
    document.documentElement.setAttribute('data-theme', this.isDarkTheme ? 'dark' : 'light');
    
    ////////////////////////////  
    // NAVIGATION & SCROLL
    ////////////////////////////

    this.$nextTick(() => {
      setTimeout(() => {
        this.calculateSectionBounds(this.sectionBounds)
      }, 100);
    });
      
    window.addEventListener('scroll', () => {
      if(!this.showAllProjects) {
        let scrollValue = window.scrollY;
        for (let i = 0; i < this.sectionBounds.length; i++) {
          if (scrollValue < this.sectionBounds[i] - 1) {
            const sections = ['about', 'projects', 'skills'];
            this.activeSection = sections[i] || 'about';
            break;
          }
        }
      } else {
        this.activeSection = 'projects';
      }
    });
    ////////////////////////////
    /////// Timeline js ////////
    ////////////////////////////
    this.$nextTick(() => {
      setTimeout(() => this.setupTimeline(), 100);
    });
    window.addEventListener("resize", this.debouncedSetupTimeline);

    function animateUp(query)
    {
      // grab all children except fun facts because it screws up the blur fade in animations
      let parent = document.querySelectorAll(`${query} > *:not(.fun-fact)`);
      parent.forEach(async (el, i) => {
        el.style.opacity = 0;
        el.style.animation = 'fadeInUp 0.5s ease forwards';
        el.style.animationDelay = `${0.05 * i}s`
        await new Promise(r => setTimeout(r, 700));
        // reset the element properties that i changed
        el.style.animationFillMode = 'none'
        el.style.animation = 'none'
        el.style.opacity = 1;
      })
    }

    // add some spicy animations
    animateUp(".left")
    animateUp(".right") 
    animateUp(".intro") 
    animateUp(".connections") 
    // animateUp(".navigation") 

    /*
    ok so the timeline has a slight offset glitch.
    basically, when my video or images still have not loaded,
    the timeline still gets set up. this sets it to a shorter height
    because the resources havent loaded yet.
    then the resources gets loaded and pushes all the elements down
    (because each has some height)

    this causes the timeline to be offset each time when the resources
    havent been cached yet and are still loading.

    lets fix it by waiting for the resource load and for each resource
    load i resetup the timeline offsets (this.debounceSetupTimeline)
    */

    let resourceElms = document.querySelectorAll(".project-header > *:not(div,p)");
    resourceElms.forEach((elm) => {
      elm.addEventListener("load", this.debouncedSetupTimeline);
    });
    
  }
}
</script>
